// @flow
/**
 * BreadCrumb Reducer
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @date: 16.09.2018
 * @time: 13:41
 */
import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({});

export default class BreadCrumbReducer extends Reducer {
    NAME = 'BreadCrumb';
    alias = {
        [ TYPES.BREADCRUMB_SET_ITEMS ]: 'onSetItems'
    };

    /**
     *
     * @param state
     * @param action
     * @returns {*|Immutable.Map<any, any>|Immutable.Map<string, any>}
     * @constructor
     */
    onSetItems ( state = DEFAULT_STATE, action ) {
        const { name, value } = action.payload;

        if ( !name ) {
            return state;
        }

        return state.set(name, value);
    }

    /**
     *
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, Array|{}|boolean>}
     */
    onDefault ( state = DEFAULT_STATE ) {
        return state;
    }
}
